/** 左侧菜单排序 */

export default {

  /** 这些为系统菜单 */
  System: 110000,
  Attachment: 110020,
  Permission: 110030,
  LocalExtension: 110050,
}